import React from "react";
import useExcelUpload, {
  generateRandomAmount,
  generateRandomDescription,
  generateRandomReferences,
} from "../../../utils/hooks/useExcelUpload";
import UploadExcelDialog from "../utils/UploadExcelEnhanced";

const getInstructions = () => [
  ["Col", "Comments"],
  ["Description", "Provide a clear description of each row."],
  [
    "Amount",
    "Enter the monetary amount associated with each row. Use numeric values only.",
  ],
  [
    "Reference",
    "You may include a reference or identifier for each row (e.g., invoice number, project code, etc.).",
  ],
];

const SavyExcelUpload = ({
  company,
  onExcelAddRows,
  open,
  handleCloseDialog,
}) => {
  const {
    selectedFile,
    uploading,
    alertMessage,
    alertSeverity,
    errorFileUrl,
    rowCount,
    handleCloseAlert,
    handleDownloadTemplate,
    handleFileChange,
    handleResetFile,
    handleUpload,
    getTemplateHeadersString,
  } = useExcelUpload({
    fileName:
      company.companyType === "investment"
        ? "investment_savy_schedule_upload_template.xlsx"
        : "trading_savy_schedule_upload_template.xlsx",
    instructions: getInstructions(),
    sampleData: Array.from({ length: 10 }, (_) => ({
      Description: generateRandomDescription(),
      Amount: generateRandomAmount(),
      Reference: generateRandomReferences(),
    })),
    validationSchema: [
      { type: "text", required: true },
      { type: "number", required: true },
      { type: "text" },
    ],
    onUpload: (excelData, rowCount) => {
      if (rowCount > 0) {
        const updatedData = [];

        excelData.forEach((row) => {
          const [Description, Amount, Reference] = row;

          updatedData.push({
            name: Description,
            amount: Amount,
            reference: Reference,
          });
        });

        onExcelAddRows(updatedData);
      }
    },
  });

  return (
    <UploadExcelDialog
      open={open}
      selectedFile={selectedFile}
      uploading={uploading}
      alertMessage={alertMessage}
      alertSeverity={alertSeverity}
      errorFileUrl={errorFileUrl}
      validRows={rowCount}
      onClose={handleCloseDialog}
      onDownloadTemplate={handleDownloadTemplate}
      onFileChange={handleFileChange}
      onUpload={handleUpload}
      onCloseAlert={handleCloseAlert}
      onReset={handleResetFile}
      templateHeadersString={getTemplateHeadersString()}
      templateInstructions={getInstructions()}
    />
  );
};

export default SavyExcelUpload;
